// extracted by mini-css-extract-plugin
export default {"additionalInfoContainer":"DashboardLayout__additionalInfoContainer___yL55r"};